<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L4.4714 3.5286C4.73175 3.78894 4.73175 4.21106 4.4714 4.4714L1.13807 7.80474C0.877722 8.06509 0.455612 8.06509 0.195262 7.80474C-0.0650874 7.54439 -0.0650874 7.12228 0.195262 6.86193L3.05719 4L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262ZM4.19526 0.195262C4.45561 -0.0650874 4.87772 -0.0650874 5.13807 0.195262L8.47141 3.5286C8.73175 3.78894 8.73175 4.21106 8.47141 4.4714L5.13807 7.80474C4.87772 8.06509 4.45561 8.06509 4.19526 7.80474C3.93491 7.54439 3.93491 7.12228 4.19526 6.86193L7.05719 4L4.19526 1.13807C3.93491 0.877722 3.93491 0.455612 4.19526 0.195262Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "NextStep2Blue",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
